module.exports = __webpack_public_path__ + "img/channel_manage.39cade1c.png";